import { styled } from "@mui/material/styles"

import { BottomSheet as UiBottomSheet } from "../BottomSheet"

type StyledBottomSheetProps = {
    height: number
}

export const BottomSheet = styled(UiBottomSheet, {
    shouldForwardProp: (prop) => prop !== "height",
})<StyledBottomSheetProps>(({ height }) => ({
    height: `${height}% !important`,
    position: "absolute",
    top: `${100 - height}% !important`,

    "& .MuiDrawer-paper": {
        height: "100% !important",
        maxHeight: "100% !important",
        position: "relative",
        transform: "translateY(0) !important",
        width: "100%",
        overflowY: "hidden",
    },
}))